import { AnchorHTMLAttributes, PropsWithChildren } from "react";
import { Link as RouterLink, useLocation } from "react-router-dom";
import { Location } from "history";

type LinkProps = Pick<AnchorHTMLAttributes<HTMLAnchorElement>, "rel" | "target" | "className"> &
  PropsWithChildren<{
    to: string | Location;
    external?: boolean;
    withParams?: boolean;
    hash?: string;

    [key: string]: any;
  }>;

export default function Link({ external = true, withParams = true, hash = "", target, ...props }: LinkProps) {
  const { to, children, ...resProps } = props;
  const { search } = useLocation();

  let toPath = to;
  let hashInPath = hash;

  if (typeof toPath === "string") {
    if (withParams) {
      const splittedPath = toPath.split("?");
      const isPathContainsHash = `${toPath}`.includes("#");
      if (isPathContainsHash) {
        // workaround when there's a hash inside the url path
        const splittedFromHash = `${splittedPath[0]}`.split("#");
        hashInPath = `#${splittedFromHash[1]}`;
        splittedPath[0] = splittedFromHash[0];
      }

      if (search) {
        if (splittedPath[1]) {
          toPath = `${splittedPath[0]}${search}&${splittedPath[1]}` + (hashInPath || hash);
        } else toPath = `${splittedPath[0]}${search}` + (hashInPath || hash);
      } else if (splittedPath[1]) {
        toPath = `${splittedPath[0]}?${splittedPath[1]}` + (hashInPath || hash);
      } else {
        toPath = `${splittedPath[0]}` + (hashInPath || hash);
      }
    } else {
      toPath = toPath + (hashInPath || hash);
    }
  }

  if (!toPath) {
    return <div {...resProps}>{children}</div>;
  }

  if ((typeof toPath === "string" && /^https?:\/\//.test(toPath)) || target === "_blank") {
    return (
      <a
        href={toPath as Pick<AnchorHTMLAttributes<HTMLAnchorElement>, "href">["href"]}
        {...((external || target === "_blank") && { target: "_blank", rel: "noopener noreferrer" })}
        {...resProps}
        onClick={(evt) => {
          evt.stopPropagation();
          resProps?.onClick?.();
        }}
      >
        {children}
      </a>
    );
  }

  return (
    <RouterLink
      to={toPath}
      {...resProps}
      onClick={(evt) => {
        evt.stopPropagation();
        resProps?.onClick?.();
      }}
    >
      {children}
    </RouterLink>
  );
}
